import React, {useMemo, useState} from 'react';

// import {Chip, Group} from '@mantine/core';

import {useModule} from '@/hooks/useModule';

import {ItemSummary} from './item_summary';
import {ItemType} from '../tags_module';
import {Button, Input} from '@mantine/core';

type Props = {

};

const ALL_ITEM_TYPES = [
    'project',
    'audio_file',
] as const as ItemType[];

export const BrowseItemsWithTagsView = (props: Props) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedTag, setSelectedTag] = useState('');
    const [selectedItemType, setSelectedItemType] = useState('');

    const tagsModule = useModule('Tags');
    const existingTags = tagsModule.useExistingTags();

    const items = tagsModule.useAnyItemsWithTag(selectedTag);

    const filteredItems = useMemo(() => {
        let currentItems = items;

        if (selectedItemType) {
            currentItems = currentItems.filter(i => i.item_type === selectedItemType);
        }

        if (searchTerm) {
            return currentItems.filter(item => {
                return item.item_type.toUpperCase().includes(searchTerm.toUpperCase());
            });
        }

        return currentItems;
    }, [items, selectedItemType, searchTerm]);

    return (
        <div>
            <div style={{border: '1px solid'}}>
                <Input
                    type='text'
                    onChange={e => setSearchTerm(e.target.value)}
                    value={searchTerm}
                />
            </div>
            <div style={{border: '1px solid'}}>
                <div>
                    Selected tag: {selectedTag}
                </div>
                <div>
                    <Button
                        onClick={() => setSelectedTag('')}
                    >
                        Deselect tag
                    </Button>
                </div>
                <div>
                    <DisplayChips
                        chips={existingTags}
                        selectedValues={selectedTag ? [selectedTag] : []}
                        onSelect={label => {
                            const isSelected = selectedTag === label;
                            if (isSelected) {
                                setSelectedTag('');
                            } else {
                                setSelectedTag(label);
                            }
                        }}
                    />
                </div>
            </div>

            <div style={{border: '1px solid'}}>
                <div>
                    Selected item type: {selectedItemType}
                </div>
                <div>
                    <Button
                        onClick={() => setSelectedItemType('')}
                    >
                        Deselect item type
                    </Button>
                </div>
                {/* <ul>
                    {ALL_ITEM_TYPES.map(itemType => (
                        <li
                            key={itemType}
                            onClick={() => setSelectedItemType(itemType)}
                        >
                            {itemType}
                        </li>
                    ))}
                </ul> */}
                <DisplayChips
                    chips={ALL_ITEM_TYPES}
                    selectedValues={selectedItemType ? [selectedItemType] : []}
                    onSelect={label => {
                        const isSelected = selectedItemType === label;
                        if (isSelected) {
                            setSelectedItemType('');
                        } else {
                            setSelectedItemType(label);
                        }
                    }}
                />
            </div>

            <div>
                Found items:
                <ul>
                    {filteredItems.map(item => (
                        <li
                            key={`${item.item_type}-${item.item_id}`}
                        >
                            <ItemSummary
                                itemType={item.item_type}
                                itemId={item.item_id}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

// type ChipData = {
//     label: string;
// }

type DisplayChipsProps = {
    chips: string[]; // ChipData[];
    selectedValues: string[];
    onSelect: (label: string) => void;
};

const DisplayChips = (props: DisplayChipsProps) => {
    return null;
    // return (
    //     <Chip.Group>
    //         <Group justify='left'>
    //             {props.chips.map(label => (
    //                 <Chip
    //                     key={label}
    //                     checked={props.selectedValues.includes(label)}
    //                     onClick={() => {
    //                         props.onSelect(label);
    //                     }}
    //                 >
    //                     {label}
    //                 </Chip>
    //             ))}
    //         </Group>
    //     </Chip.Group>
    // )
};
